import { Card } from '@/components/ui/card';
import { Wallet, Microscope, LockKeyhole } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const VCWedge = () => {
  const { t } = useTranslation();

  const cards = [
    { icon: Wallet, title: t('vcWedge.card1.title'), description: t('vcWedge.card1.description') },
    {
      icon: Microscope,
      title: t('vcWedge.card2.title'),
      description: t('vcWedge.card2.description'),
    },
    {
      icon: LockKeyhole,
      title: t('vcWedge.card3.title'),
      description: t('vcWedge.card3.description'),
    },
  ];

  return (
    <section className="py-16 px-6 md:px-8 bg-card">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-semibold mb-6 tracking-tight">
            {t('vcWedge.heading')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('vcWedge.subheading')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <Card
                key={card.title}
                className="p-8 bg-background border border-border hover:border-foreground/30 transition-colors"
              >
                <div className="mb-4 text-foreground">
                  <Icon className="size-10" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-foreground">{card.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{card.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
